"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      height: '44px',
      borderRadius: '10px',
      fontSize: '13px',
      '& .loader': {
        left: '50%',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        position: 'absolute'
      }
    },
    label: {
      fontSize: 'inherit',
      lineHeight: 1.41
    },
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 14
      }
    },
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 16
      }
    },
    sizeLarge: {
      minHeight: '50px'
    }
  };
}, {
  name: 'Button'
});
exports.useStyles = useStyles;